import { render, staticRenderFns } from "./artical.vue?vue&type=template&id=1e87eb3c"
import script from "./artical.vue?vue&type=script&lang=js"
export * from "./artical.vue?vue&type=script&lang=js"
import style0 from "./artical.vue?vue&type=style&index=0&id=1e87eb3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports